// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__iWXcB","range":"MonthRangeSwitch_range__2GYO8","disabled":"MonthRangeSwitch_disabled__2b5xq"};